import styled from "styled-components";

export const AssetTypeFormModalStyle = styled.div`

`;
